<h2 mat-dialog-title>Choisir une offre pour l'accès <i>n</i> du site #{{ site()?.id }} - {{ site()?.name }}</h2>

<mat-dialog-content>
    <div class="flex flex-col h-full">
        <ag-grid-angular
            class="p-2 grid-dimensions"
            [rowData]="rows"
            [columnDefs]="columnDefs"
            [rowSelection]="{mode: 'singleRow', enableClickSelection: true, enableSelectionWithoutKeys: true}"
            [autoSizeStrategy]="{type: 'fitGridWidth'}"
            >
        </ag-grid-angular>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button [mat-dialog-close]="false">Annuler</button>
    <button mat-stroked-button >Sélectionner</button>
</mat-dialog-actions>